import React, { useEffect, useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { MdEdit } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CrudIcon, Search } from 'src/components';
import DragableTable from 'src/components/DragableTable';
import { onDragEnd } from 'src/components/DragableTable/onDragEnd';
import Button from 'src/components/button';
import Loader from 'src/components/loader';
import { fetchItemCategories } from 'src/redux/action/item.action';
import { RootState } from 'src/redux/reducers';
import AddCategory from './crud/AddEditCategory';
interface IProps {}

const Category: React.FC<IProps> = ({}) => {
  const [showModal, setShowModal] = React.useState(true);
  const [query, setQuery] = React.useState<string>('');
  const [editCategory, setEditCategory] = useState<boolean>(false);
  const [editCategoryId, setEditCategoryId] = useState('');
  const [editCategoryData, setEditCategoryData] = useState([]);
  const [orderData, setOrderData] = useState<any>([]);
  const [pageSize, setPageSize] = useState<any>(0);
  const [pageIndex, setPageIndex] = useState<any>(0);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { categoryData, error, loading } = useSelector(
    ({ itemCategory }: RootState) => itemCategory
  );

  const handleModal = () => {
    setShowModal(!showModal);
    setEditCategoryData([]);
  };

  const onDragEndHandler = (result: any) => {
    onDragEnd(
      result,
      orderData,
      setOrderData,
      categoryData,
      '/categories/change/order',
      pageIndex,
      pageSize
    );
  };

  React.useEffect(() => {
    dispatch(fetchItemCategories() as any);
  }, [dispatch]);

  const handleEditCategory = (data: any) => {
    setEditCategoryId(data?.categoryInfo?.id);
    setEditCategoryData(data);
    setEditCategory(true);
  };

  useEffect(() => {
    editCategory &&
      navigate('/edit-category', {
        state: {
          editCategoryData: editCategoryData,
          editCategoryId: editCategoryId,
          editCategory: editCategory,
        },
      });
  }, [editCategoryData, editCategory, editCategoryId]);

  const handleButtonClick = () => {
    setShowModal(false);
    setEditCategory(false);
    setEditCategoryData([]);
    setEditCategoryId('');
    setTimeout(() => {
      setShowModal(true);
    }, 100);
  };

  const searchCategoryData = categoryData.filter((item: any) => {
    if (query === '') {
      return item;
    } else if (
      item?.categoryInfo.name?.toLowerCase().includes(query.toLowerCase())
    ) {
      return item;
    }
  });

  const tableColumn = [
    {
      Header: 'Category Name',
      accessor: 'categoryInfo',
      Cell: (row: {
        value: { shape: string; color: string; name: string };
      }) => (
        <div className="flex flex-row-reverse items-center space-x-4 justify-end gap-4">
          <p className="text-text-black"> {row?.value?.name} </p>
          <div
            className={`${
              row?.value?.shape === 'square' ? 'rounded' : 'rounded-full'
            } w-8 h-8`}
            style={{ backgroundColor: `${row?.value?.color}` }}
          ></div>
        </div>
      ),
    },
    {
      Header: 'Number Of Options',
      accessor: (row: any) => {
        return row?.numberofitems || row?.numberOfItems;
      },
    },
    {
      Header: 'Action',
      Cell: (row: any) => (
        <div className="flex gap-4">
          <CrudIcon
            data={row?.cell?.row?.original?.categoryInfo}
            url="/categories/remove"
            fetchData={fetchItemCategories() as any}
          >
            <div
              className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
              onClick={() => handleEditCategory(row?.cell?.row?.original)}
            >
              <MdEdit color="#4062FF" />
            </div>
          </CrudIcon>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="grid-cols-12 gap-4 grid z-2 ">
        <div className="col-span-12 pb-10">
          <div className="flex items-center justify-between ">
            <Search
              placeholder="search category"
              query={query}
              setQuery={setQuery}
            />
            <Button
              text={'Add category'}
              variant="primary"
              onClick={handleButtonClick}
              icon={<AiOutlinePlus size={20} />}
            />
          </div>
          {loading ? (
            <Loader />
          ) : (
            <DragableTable
              onDragEnd={onDragEndHandler}
              pagination={true}
              tableColumn={tableColumn}
              tableData={orderData.length > 0 ? orderData : searchCategoryData}
              setPageIndex={setPageIndex}
              setPageSizes={setPageSize}
            />
          )}
        </div>
      </div>
      <AddCategory
        categoryData={{
          editCategoryData: editCategoryData,
          editCategoryId: editCategoryId,
          editCategory: editCategory,
        }}
        handleModal={handleModal}
        showModal={showModal}
      />
    </>
  );
};
export default React.memo(Category);
